import React, { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, LineElement, PointElement, Title, Tooltip, Legend } from 'chart.js';
import { api } from '../../../api';
import axios from 'axios';

// Enregistrement des éléments nécessaires dans ChartJS
ChartJS.register(CategoryScale, LinearScale, LineElement, PointElement, Title, Tooltip, Legend);

const LineChartSuperAdmin = ({annee}) => {
  const user_id = sessionStorage.getItem('user_id');
  const [loading, setLoading] = useState(false);

  const [montant1, setMontant1] = useState(0); const [montant2, setMontant2] = useState(0); const [montant3, setMontant3] = useState(0);  
  const [montant4, setMontant4] = useState(0); const [montant5, setMontant5] = useState(0); const [montant6, setMontant6] = useState(0); 
  const [montant7, setMontant7] = useState(0); const [montant8, setMontant8] = useState(0); const [montant9, setMontant9] = useState(0); 
  const [montant10, setMontant10] = useState(0); const [montant11, setMontant11] = useState(0); const [montant12, setMontant12] = useState(0); 

  const [totalMensuel, setTotalMensuel] = useState({});
    
    const getTotalMontantMensuel = async () => {
        try {
          const response = await axios.get(api + '/api/getTotalMontantMensuel');
          setTotalMensuel(response.data);
          // console.log(response.data);
        } catch (error) {
          console.error('Error fetching user info:', error);
        }
  };

  useEffect(() => {
    getTotalMontantMensuel();
  }, []);

  // Données du graphique
  const data = {
    labels: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'], // Labels pour l'axe des X
    datasets: [
      {
        label: 'Montant (AR)', // Légende pour le premier dataset
        // data: [montant1, montant2, montant3, montant4, montant5, montant6, montant7, montant8 ,montant9, montant10, montant11, montant12], // Données pour le premier dataset
        data: [totalMensuel[1], totalMensuel[2], totalMensuel[3], totalMensuel[4], totalMensuel[5], totalMensuel[6], totalMensuel[7], totalMensuel[8] ,totalMensuel[9], totalMensuel[10], totalMensuel[11], totalMensuel[12]],
        backgroundColor: 'rgba(77, 219, 255, 0.5)', // Couleur de fond (transparent pour les lignes)
        borderColor: 'rgba(77, 219, 255, 1)', // Couleur de la ligne
        borderWidth: 2, // Épaisseur de la ligne
        fill: false, // Ne pas remplir l'aire sous la courbe
      },
    ],
  };

  // Options de configuration du graphique
  const options = {
    responsive: true,
    plugins: {
      legend: { display: true }, // Afficher les légendes
      tooltip: { mode: 'index' }, // Afficher les tooltips pour les points
    },
    scales: {
      y: {
        beginAtZero: true, // L'axe Y commence à 0
        title: {
          display: false,
          text: 'Valeur', // Titre pour l'axe Y
        },
      },
      x: {
        title: {
          display: false,
          text: 'Mois', // Titre pour l'axe X
        },
      },
    },
  };

  return loading ? (

        <>
           <div className="flex justify-center items-center mt-28">
            <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
          </div>
        </>

  ) : (
    <div className="w-full "> {/* Fixer la hauteur du conteneur */}
    <Line data={data} options={options}  height={90}/>
  </div>
  );
};

export default LineChartSuperAdmin;
